import axios from "axios";

var urlApi = (window.location.host.includes("localhost") ? "http://localhost:3000" : "") + "/api/public";

const axiosInstance = axios.create({
  baseURL: urlApi
});

axiosInstance.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("pwK");
    if (token) {
      config.headers.Authorization = token;
      config.headers.Versao = process.env.VUE_APP_VERSAO;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export const api = {
  get(endpoint) {
    return axiosInstance.get(endpoint, {
      headers: { "Access-Control-Allow-Origin": "*" }
    });
  },
  post(endpoint, body) {
    return axiosInstance.post(endpoint, body);
  },
  put(endpoint, body) {
    return axiosInstance.put(endpoint, body);
  },
  delete(endpoint) {
    return axiosInstance.delete(endpoint);
  },
  loginAuth(body) {
    return axios.post(urlApi + "/ass/paywall/login/auth-token", body);
  },
  login(body) {
    return axios.post(urlApi + "/ass/paywall/login/access-token", body);
  }
};
